export default "/images/642ad8ab8a4e3706194a3e201b489233.avif";